import { useState } from 'react';
import {
    DatabaseBlockState,
    DatabaseBlockStateProvider,
} from './databaseViewBlockInterface';
import { DatabaseBlockStateValues } from './databaseViewBlockModel';

export function createDatabaseStateProvider(): DatabaseBlockStateProvider {
    return {
        useState(context, props) {
            const [state, setState] = useState<DatabaseBlockStateValues>({
                filterVisible: false,
                filterValues: {},
            });
            return {
                filterVisible: {
                    value: state.filterVisible,
                    onChange(value) {
                        setState((state) => ({ ...state, filterVisible: value }));
                    },
                },
                filter: {
                    value: state.filterValues,
                    onChange(value) {
                        setState((state) => ({ ...state, filterValues: value }));
                    },
                },
            };
        },
    };
}
